module.exports = __webpack_public_path__ + "static/media/beijing1.bdf3750b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/imgForTest/beijing1.jpg
// module id = 1170
// module chunks = 0